/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-08-24 14:35:58
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-01-26 15:31:22
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/api/form.js
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

// 获取问卷列表
export function getquestioniareList(data) {
  return request({
    url: '/user/admin/questionnaire/getList',
    method: 'POST',
    data,
  })
}

// 新增问卷信息
export function addQuestioniareList(data) {
  return request({
    url: '/user/admin/questionnaire/add',
    method: 'POST',
    data,
  })
}

// 编辑问卷信息
export function editQuestioniareList(data) {
  return request({
    url: '/user/admin/questionnaire/update',
    method: 'POST',
    data,
  })
}

// 获取问卷单个详情
export function getquestioniareDetail(code) {
  return request({
    url: `/user/admin/questionnaire/get/${code}`,
    method: 'GET',
  })
}

// 匿名问卷导出
export function exportQuestion(params) {
  return request({
    url: `/user/questionnaire/export/anonymous`,
    method: 'GET',
    params,
  })
}
